export default __webpack_public_path__ + "media/flavours/glitch/images/glitch-preview-167a72fe96050ecd7616a3d84e7926f8.png";